module.exports = __webpack_public_path__ + "static/media/shield-question.acff7d74.svg";